define('controller/MedicalTestController',['require','lib/controller/BaseController','view/controller/medical-test/MedicalTestCheckView','model/MedicalTestModel'],function (require) {

    var BaseController = require('lib/controller/BaseController');
    var MedicalTestCheckView = require('view/controller/medical-test/MedicalTestCheckView');
    var MedicalTestModel = require('model/MedicalTestModel');

    /**
     * Medical Test Controller
     *
     * @class MedicalTestController
     */
    return BaseController.extend({
        
        check: function (id, code) {
            var model = new MedicalTestModel({
                id: id
            }, {
                code: code,
            });
            
            model.fetch();
            
            var view = new MedicalTestCheckView({
                model: model,
            });
            
            this.getMainLayout().getContentRegion().show(view);
        }
        
    });

});
